import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './app/App'
import { AuthProvider } from './context/AuthContext'
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary'
import { FeedbackProvider } from './context/FeedbackContext'
import { PwaPrompt } from './components/PwaPrompt'
import { handleChunkLoadError } from './utils/chunk-error'
import './styles/index.css'

// Tangani error chunk gagal dimuat saat rilis/deployment baru
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  handleChunkLoadError()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <FeedbackProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <PwaPrompt />
          </AuthProvider>
        </BrowserRouter>
      </FeedbackProvider>
    </GlobalErrorBoundary>
  </StrictMode>,
)
